import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitojaipurcab() {



    const cardData = {

keyword: "Mumbai to Jaipur Cab",

headingDescription:
    "Mumbai Airport Cab offers reliable and affordable Mumbai to Jaipur Cab services for long-distance travel, Rajasthan tours, family vacations, business trips, and one-way or round-trip journeys. We provide a wide range of well-maintained vehicles including Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus with professional and experienced chauffeurs. With 24x7 availability, transparent pricing, doorstep pickup in Mumbai, and safe highway driving across Maharashtra, Gujarat, and Rajasthan routes, we ensure a smooth, comfortable, and hassle-free travel experience to Jaipur.",

topPlaces: [
    {
        title: "Amer Fort",
        description:
            "Amer Fort is one of Jaipur’s most famous forts known for its stunning architecture, mirror work, courtyards, and panoramic hilltop views, attracting tourists from across India."
    },
    {
        title: "Hawa Mahal",
        description:
            "Hawa Mahal, also known as the Palace of Winds, is an iconic pink sandstone structure famous for its unique honeycomb windows and royal heritage."
    },
    {
        title: "City Palace Jaipur",
        description:
            "City Palace is a royal residence showcasing museums, courtyards, and artifacts that reflect Jaipur’s rich royal history and culture."
    },
    {
        title: "Jantar Mantar",
        description:
            "Jantar Mantar is a UNESCO World Heritage Site featuring ancient astronomical instruments used to study stars, time, and planetary movements."
    },
    {
        title: "Nahargarh Fort",
        description:
            "Nahargarh Fort offers breathtaking sunset views of Jaipur city and is a popular spot for photography and evening visits."
    },
    {
        title: "Jaigarh Fort",
        description:
            "Jaigarh Fort is known for housing the world’s largest cannon on wheels and offers panoramic views of the Aravalli hills."
    },
    {
        title: "Jal Mahal",
        description:
            "Jal Mahal is a beautiful palace located in the middle of Man Sagar Lake, famous for its scenic beauty and photography points."
    },
    {
        title: "Albert Hall Museum",
        description:
            "Albert Hall Museum is the oldest museum in Rajasthan, showcasing artifacts, paintings, and historical exhibits."
    },
    {
        title: "Chokhi Dhani",
        description:
            "Chokhi Dhani is a cultural village resort offering traditional Rajasthani food, folk dance, and cultural experiences."
    },
    {
        title: "Johari Bazaar",
        description:
            "Johari Bazaar is Jaipur’s famous shopping market known for jewelry, textiles, handicrafts, and traditional Rajasthani items."
    }
],



services: [
{
name: "Mumbai to Jaipur Cab",
description: "Mumbai Airport Cab offers Mumbai to Jaipur Cab service for safe, comfortable, and reliable long-distance travel from Mumbai to the royal city of Jaipur in Rajasthan. Whether you are travelling for tourism, business meetings, family visits, heritage exploration, or vacation, we provide well-maintained vehicles including Sedan, SUV, Innova, Innova Crysta, Kia Carens, Tempo Traveller, and luxury cars. Our professional chauffeurs ensure smooth highway driving, timely pickup, passenger safety, and a stress-free journey experience. With doorstep pickup from Mumbai, flexible travel plans, transparent pricing, luggage assistance, and 24x7 support, we make your intercity Rajasthan journey comfortable and enjoyable."
},
{
name: "Mumbai to Jaipur Taxi",
description: "Mumbai to Jaipur Taxi service by Mumbai Airport Cab provides dependable intercity transportation with clean, air-conditioned vehicles and experienced chauffeurs. Ideal for families, tourists, and corporate travellers, we ensure safe highway travel, punctual pickup, and comfortable seating for a smooth journey from Mumbai to Jaipur."
},
{
name: "Mumbai to Jaipur Cab Fare",
description: "Mumbai to Jaipur Cab Fare with Mumbai Airport Cab is transparent, affordable, and based on vehicle type, distance, and travel requirements. We provide clear pricing with no hidden charges and flexible options for one-way and round-trip journeys, ensuring cost-effective long-distance travel with comfort and reliability."
},
{
name: "Mumbai to Jaipur Car Rental",
description: "Mumbai Airport Cab offers Mumbai to Jaipur Car Rental service with chauffeur-driven vehicles for long-distance intercity travel. Our fleet includes comfortable sedans and spacious SUVs ideal for family trips, business travel, and tourism. We ensure safe driving, luggage support, and flexible itineraries for a smooth travel experience."
},
{
name: "Mumbai to Jaipur One Way Cab",
description: "Mumbai to Jaipur One Way Cab service provides affordable travel for passengers who need a single journey without return charges. Mumbai Airport Cab ensures transparent pricing, comfortable vehicles, and professional chauffeurs for intercity relocation, tourism, and business travel."
},
{
name: "Mumbai to Jaipur Outstation Cab",
description: "Mumbai to Jaipur Outstation Cab service offers reliable long-distance transportation with well-maintained vehicles and experienced drivers. Mumbai Airport Cab ensures safe highway driving, flexible schedules, and comfortable seating for stress-free intercity journeys."
},
{
name: "Mumbai to Jaipur Long Distance Cab",
description: "Mumbai to Jaipur Long Distance Cab service is designed for extended highway journeys with maximum comfort and safety. Mumbai Airport Cab provides experienced chauffeurs, air-conditioned vehicles, luggage assistance, and smooth travel planning for a hassle-free experience."
},
{
name: "Mumbai to Jaipur Rajputana Tour Cab",
description: "Mumbai to Jaipur Rajputana Tour Cab service is specially designed for exploring Rajasthan’s royal heritage, forts, palaces, and cultural landmarks. Mumbai Airport Cab ensures comfortable vehicles, experienced drivers, and well-planned travel routes for a memorable Rajasthan tour experience."
},
{
name: "Mumbai to Jaipur Family Cab",
description: "Mumbai to Jaipur Family Cab service ensures safe and comfortable transportation for families travelling together. Mumbai Airport Cab provides spacious vehicles, luggage-friendly travel, experienced chauffeurs, and flexible booking options for a stress-free long journey."
},
{
name: "Mumbai to Jaipur Innova Cab",
description: "Mumbai Airport Cab offers Mumbai to Jaipur Innova Cab service for families and groups needing spacious and comfortable travel. Our Innova vehicles provide ample seating, luggage space, and smooth ride quality for long-distance journeys."
},
{
name: "Mumbai to Jaipur SUV Cab",
description: "Mumbai to Jaipur SUV Cab service provides powerful and comfortable vehicles suitable for long highway travel. Mumbai Airport Cab ensures safe driving, spacious interiors, and smooth journey experience for families and groups travelling together."
},
{
name: "Mumbai to Jaipur Round Trip Cab",
description: "Mumbai to Jaipur Round Trip Cab service offers complete return journey solutions for tourists, business travellers, and families. Mumbai Airport Cab ensures flexible scheduling, professional chauffeurs, and comfortable vehicles for a smooth round trip experience."
},
{
name: "Mumbai to Jaipur Travel Service",
description: "Mumbai to Jaipur Travel Service provides complete transportation solutions for tourists, families, and corporate travellers. Mumbai Airport Cab ensures safe, comfortable, and well-organized intercity travel with professional drivers and flexible itineraries."
},
{
name: "Mumbai to Jaipur Business Cab",
description: "Mumbai to Jaipur Business Cab service is designed for corporate professionals requiring reliable and punctual transportation. Mumbai Airport Cab ensures executive comfort, professional chauffeurs, and timely service for productive business travel."
},
{
name: "Mumbai to Jaipur Highway Cab",
description: "Mumbai to Jaipur Highway Cab service ensures safe and efficient long-distance travel across major highway routes. Mumbai Airport Cab provides experienced chauffeurs, optimized routes, and well-maintained vehicles for smooth intercity journeys."
},
{
name: "Mumbai to Jaipur Budget Cab",
description: "Mumbai to Jaipur Budget Cab service offers economical travel solutions without compromising safety or comfort. Mumbai Airport Cab ensures affordable pricing, clean vehicles, and reliable drivers for cost-effective long-distance travel."
},
{
name: "Mumbai to Jaipur Express Cab",
description: "Mumbai to Jaipur Express Cab service provides fast and efficient transportation for urgent travel needs. Mumbai Airport Cab ensures quick pickup, optimized routes, and professional drivers for timely arrival at your destination."
},
{
name: "Mumbai to Jaipur Night Travel Cab",
description: "Mumbai to Jaipur Night Travel Cab service provides safe overnight transportation for long-distance travellers. Mumbai Airport Cab ensures experienced drivers, secure travel conditions, and comfortable vehicles for peaceful night journeys."
},
{
name: "Mumbai to Jaipur Tour Package Cab",
description: "Mumbai to Jaipur Tour Package Cab service offers complete travel solutions for sightseeing and vacation trips. Mumbai Airport Cab ensures well-planned itineraries, comfortable vehicles, and professional chauffeurs for a smooth and enjoyable Jaipur tour experience."
}
],

tableData: [
["Mumbai to Jaipur Cab","Mumbai to Jaipur Taxi"],
["Mumbai to Jaipur Cab Fare","Mumbai to Jaipur Car Rental"],
["Mumbai to Jaipur One Way Cab","Mumbai to Jaipur Outstation Cab"],
["Mumbai to Jaipur Long Distance Cab","Mumbai to Jaipur Rajputana Tour Cab"],
["Mumbai to Jaipur Family Cab","Mumbai to Jaipur Innova Cab"],
["Mumbai to Jaipur SUV Cab","Mumbai to Jaipur Round Trip Cab"],
["Mumbai to Jaipur Travel Service","Mumbai to Jaipur Business Cab"],
["Mumbai to Jaipur Highway Cab","Mumbai to Jaipur Budget Cab"],
["Mumbai to Jaipur Express Cab","Mumbai to Jaipur Night Travel Cab"]
],
















whychoose: [
    {
        WhyChooseheading: "Reliable Mumbai to Jaipur Cab Service",
        WhyChoosedescription: "Mumbai Airport Cabs provides dependable Mumbai to Jaipur Cab services for tourists, families, business travelers, corporate professionals, and long-distance travelers seeking comfortable interstate transportation."
    },
    {
        WhyChooseheading: "Convenient Travel to the Pink City",
        WhyChoosedescription: "Travel comfortably from Mumbai to Jaipur, one of India's most famous tourist destinations known for royal palaces, historic forts, cultural heritage, and vibrant markets."
    },
    {
        WhyChooseheading: "Perfect for Tourism and Business Travel",
        WhyChoosedescription: "Whether you are planning a family vacation, honeymoon, sightseeing tour, business meeting, wedding event, or corporate visit, our cab service offers a convenient travel solution."
    },
    {
        WhyChooseheading: "Wide Range of Vehicle Options",
        WhyChoosedescription: "Customers can choose Sedan cars, Ertiga, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, Mini Buses, and premium vehicles according to passenger count and travel requirements."
    },
    {
        WhyChooseheading: "One-Way and Round Trip Facilities",
        WhyChoosedescription: "Whether you require a one-way transfer, round trip, multi-day Rajasthan tour, or customized itinerary, we provide flexible booking options."
    },
    {
        WhyChooseheading: "Pickup Available Across Mumbai",
        WhyChoosedescription: "Doorstep pickup services are available from Mumbai Airport, Navi Mumbai, Thane, Dombivli, Kalyan, Andheri, Borivali, Bandra, Dadar, Powai, and nearby locations."
    },
    {
        WhyChooseheading: "Experienced Drivers for Interstate Travel",
        WhyChoosedescription: "Our professional chauffeurs are experienced in long-distance interstate routes and ensure safe, comfortable, and stress-free travel throughout the journey."
    },
    {
        WhyChooseheading: "Ideal for Families, Tourists, and Groups",
        WhyChoosedescription: "From solo travelers and couples to family groups and corporate teams, we provide suitable vehicles for every travel requirement."
    }
]
};

const faqData = [
    {
        question: "Why do travelers book Mumbai to Jaipur Cabs?",
        answer: "Jaipur attracts visitors for tourism, business meetings, family functions, destination weddings, cultural experiences, and historical sightseeing."
    },
    {
        question: "Can I book a one-way cab from Mumbai to Jaipur?",
        answer: "Yes, one-way cab services are available along with round-trip and customized Rajasthan travel packages."
    },
    {
        question: "Which vehicle is suitable for Mumbai to Jaipur travel?",
        answer: "Sedan cars, Ertiga, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, and Mini Buses are available according to passenger count and travel preferences."
    },
    {
        question: "Do you provide Rajasthan tour packages?",
        answer: "Yes, customers can book customized Rajasthan tours covering Jaipur, Udaipur, Jodhpur, Jaisalmer, Pushkar, Ajmer, and other destinations."
    },
    {
        question: "Can families travel comfortably to Jaipur?",
        answer: "Yes, we provide spacious and comfortable vehicles suitable for families, senior citizens, children, and long-distance travelers."
    },
    {
        question: "Are Tempo Travellers available for group tours?",
        answer: "Yes, Tempo Travellers and Mini Buses are available for family groups, tourist groups, corporate teams, and destination wedding transportation."
    },
    {
        question: "Can multiple sightseeing locations be included during the trip?",
        answer: "Yes, customers can customize their itinerary and include forts, palaces, temples, tourist attractions, and nearby Rajasthan destinations."
    },
    {
        question: "Can I get pickup from Mumbai Airport?",
        answer: "Yes, pickup services are available from Mumbai Airport, hotels, railway stations, offices, and residential locations."
    },
    {
        question: "Is advance booking recommended for Mumbai to Jaipur travel?",
        answer: "Yes, advance booking is recommended to secure your preferred vehicle, especially during holiday seasons and wedding periods."
    },
    {
        question: "How can I book a Mumbai to Jaipur Cab?",
        answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Karan Mehta",
        feedback:
            "Our Rajasthan family vacation started with a comfortable Mumbai to Jaipur cab journey. The vehicle was spacious, the driver was professional, and the trip was exceptionally smooth.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Poonam Agarwal",
        feedback:
            "We booked a cab for a wedding event in Jaipur and were highly satisfied with the service. The vehicle was clean, comfortable, and the travel experience exceeded our expectations.",
        rating: 5
    }
];































   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];













const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Mumbai to Jaipur Cab",
"image": "https://www.mumbaiairportcabs.com/assets/images/mumbai-to-jaipur-cab.jpg",
"description": "Book Mumbai to Jaipur cab service for long-distance travel, business trips, and family journeys. Mumbai Airport Cabs offers reliable outstation taxi service with professional drivers, comfortable vehicles, and flexible one-way and round-trip options.",
"brand": {
"@type": "Brand",
"name": "Mumbai Airport Cabs"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.mumbaiairportcabs.com/mumbai-to-jaipur-cab"
}
};





    return (
        <div>

<Helmet>
  <title>Mumbai to Jaipur Cab | Outstation Taxi Service | +91 9545731161</title>

<meta
 name="description"
 content="Book Mumbai to Jaipur cab for long-distance travel, family trips, and business journeys. Safe and comfortable outstation taxi service with professional drivers and 24x7 availability."
/>

<meta
 name="keywords"
 content="mumbai to jaipur cab, mumbai to jaipur taxi, mumbai to jaipur cab fare, mumbai to jaipur car rental, mumbai to jaipur one way cab, mumbai to jaipur outstation cab"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>








            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/42.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitojaipurcab;